<template>
  <div name="hrms15e-item" class="evaluation-item clearfix">
    <div class="col-xs-12 choice clear-padding">
      <item-desc :mainDesc="item.numitem + '. ' + item.desc_numitem"
                 :defineDesc="item.definit"
                 :classSubject="'subject'" />
      <!-- {{ item.numitem }} {{ item.desitem }} -->
    </div>
    <div class="col-xs-12 clear-padding">
      <div class="special">
        <form class="form-horizontal ">
          <div class="form-group margin-b-5">
            <label class="col-md-3 control-label">{{ labels['HRAP31EC3']['140'] }}</label>
            <div class="col-md-4 ">
              <hrms-dropdown  v-model="item.flgdqtysc"
                              :options="dropdowns.flgdqtysc[nowLang]"
                              :disabled="disabled || (flgdedbeh === '2')" />
            </div>
          </div>
        </form>
      </div>
      <div v-for="choice in choices" class="choice">
        <div class="col-xs-12 clear-padding">
          <div class="col-xs-2 col-md-1 clear-padding">
            <input class="radio-size" type="radio" :disabled="disabled" :value="choice.grditem" :id="name + '-' + dataGroup.numgrup + '-' + item.numitem + '-' + choice.grditem" v-model="item.graditem" />
            <label :for="name + '-' + dataGroup.numgrup + '-' + item.numitem + '-' + choice.grditem" class="radio-label"></label>
          </div>
          <!-- <item-desc :dataGroup="dataGroup"
                     :item="item"
                     :choice="choice" /> -->
          <item-desc :mainDesc="choice.grad + ' : ' + choice.desc_grditem + ' (' + parseFloat(choice.qtyscor).toFixed(2) + ' ' + labelsHrms15e['C40'] + ')'"
                     :defineDesc="choice.definit" />
        </div>
      </div>
    </div>
    <div class="col-xs-12 clear-padding ">
      <div class="col-xs-12 clear-padding">
        <div class="weight-box clearfix">
          <div class="col-xs-12 col-md-4 weight-content"><i class="fa fa-star"></i> {{ labels['HRAP31EC3']['150'] }} : {{ parseFloat(item.qtywgt).toFixed(2) }}</div>
          <div class="col-xs-12 col-md-4 weight-content"><i class="fa fa-list-ul"></i> {{ labels['HRAP31EC3']['165'] }} : {{ calQtyScore(item, choices) }}</div>
          <div class="col-xs-12 col-md-4 weight-content"><i class="fa fa-list-ul"></i> {{ labelsHrms15e['C90'] }} : {{ calResultScore(item, choices) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import itemDesc from 'components/hrms15e/itemDesc1'

export default {
  name: 'hrms15e-item',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    dropdowns: {
      type: Object
    },
    nowLang: {
      type: String,
      default: 'th'
    },
    item: {
      type: Object
    },
    labels: {
      type: Object
    },
    dataGroup: {
      type: Object,
      required: true
    },
    choices: {
      type: Array,
      default () {
        return []
      }
    },
    name: {
      type: String,
      required: true
    },
    qtydabs: {
      type: [ String, Number ],
      required: true
    },
    qtydleav: {
      type: [ String, Number ],
      required: true
    },
    qtydpuns: {
      type: [ String, Number ],
      required: true
    },
    flgdedbeh: {
      type: String
    },
    labelsHrms15e: {
      type: Object
    }
  },
  methods: {
    calQtyScore (item, choices) {
      let choiceFiltered = choices.filter((choice) => {
        return choice.grditem === item.graditem
      })
      let qtyscor = 0
      let resultQtyscor = 0
      let grad = ''
      if (choiceFiltered.length > 0) {
        qtyscor = parseFloat(choiceFiltered[0].qtyscor)
        grad = choiceFiltered[0].grad
      }
      if (item.flgdqtysc === '1') {
        resultQtyscor = qtyscor * parseFloat(item.qtywgt) - this.qtydabs
      } else if (item.flgdqtysc === '2') {
        resultQtyscor = qtyscor * parseFloat(item.qtywgt) - this.qtydleav
      } else if (item.flgdqtysc === '3') {
        resultQtyscor = qtyscor * parseFloat(item.qtywgt) - this.qtydpuns
      } else {
        resultQtyscor = qtyscor * parseFloat(item.qtywgt)
      }
      this.$set(item, 'qtyscor', (resultQtyscor > 0) ? resultQtyscor : 0)
      this.$set(item, 'grad', grad)
      return qtyscor.toFixed(2)
    },
    calResultScore (item, choices) {
      let choiceFiltered = choices.filter((choice) => {
        return choice.grditem === item.graditem
      })
      let qtyscor = 0
      let resultQtyscor = 0
      if (choiceFiltered.length > 0) {
        qtyscor = parseFloat(choiceFiltered[0].qtyscor)
      }
      if (item.flgdqtysc === '1') {
        resultQtyscor = qtyscor * parseFloat(item.qtywgt) - this.qtydabs
      } else if (item.flgdqtysc === '2') {
        resultQtyscor = qtyscor * parseFloat(item.qtywgt) - this.qtydleav
      } else if (item.flgdqtysc === '3') {
        resultQtyscor = qtyscor * parseFloat(item.qtywgt) - this.qtydpuns
      } else {
        resultQtyscor = qtyscor * parseFloat(item.qtywgt)
      }
      return (resultQtyscor > 0) ? resultQtyscor.toFixed(2) : 0.00
    }
  },
  components: {
    itemDesc
  }
}
</script>



// WEBPACK FOOTER //
// item1.vue?51b515dc